import { Navigate, Outlet } from 'react-router-dom';
import {
  RESTAURANT_USER_ROLE,
  useAuthUserRestaurant,
} from '@durma-soft/gros-sdk';

export const UserCanAccessRestaurantTrackMiddleware = () => {
  const { role } = useAuthUserRestaurant();

  if (role !== RESTAURANT_USER_ROLE.TRACK_EMPLOYEE) {
    return (
      <>
        <Navigate to="/" />
        <Outlet />
      </>
    );
  }

  return (
    <>
      <Outlet />
    </>
  );
};
